import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from "../../environments/environment";
@Injectable({
	providedIn: 'root'
})
export class EventHistoryService {

	baseURL = environment.baseAPIURL;

	constructor( private readonly http  : HttpClient) { }

	getEventHistory(eventId) {
		return this.http.get<any>(`${this.baseURL}/aetHistory/getBillingHistory/${eventId}`, { responseType: 'json' }
		)
			.pipe(catchError(this.handleError));
	}
	private handleError(error: HttpErrorResponse) {
		return throwError(error.message || "Server Error");
	}
}